import React, { useEffect, useState } from 'react'
import _ from "lodash";

import Loader from "./../Common/loader";
import tick from "../../assets/img/check_circle.png";
import SampleDocsUpload from "../../UI_Design/InstantNIDWithOCR/assets/SampleDocsUpload.png";
import InputField from '../InputField';
import InstantNIDDropDown from './IntantNIDDropDown';
import NationalIdFormWithOCR from './NationalIDWithOCR';
import InstantNIDForm from './InstantNIDForm';
import {
  getNIDDetails,
  uploadFileViaMultipartNID,
  saveNIDDetails,
  removeUploadedFile,
  deleteSaveNIDDetails,
  getNIDDetailsWithOCR,
  savePan,
  deleteSavePanDetails,
} from "../../Actions/nidAction";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function IntantNIDContainer(props) {
  const { nidDetails } = props;
  const { check_status, fields, info, nidList, ocr_status, selfie, showProfilePreview , digilockerCompleted} = nidDetails || {};
  const { check, nid} = nidList || {};

//   let nid = [
//     {
//         "check_id": 45,
//         "label": "PAN CARD",
//         "is_mandatory": 1,
//         "case_check_id": 2299106,
//         "field_index": "PAN_fields"
//     },
//     {
//         "check_id": 235,
//         "label": "AADHAAR",
//         "is_mandatory": 1,
//         "field_index": "Aadhaar_Fields",
//         "case_check_id" : 2300212
//     },
//     {
//         "check_id": 101,
//         "label": "DRIVING LICENSE",
//         "is_mandatory": 1,
//         "field_index": "Driving_Fields"
//     }
// ]

  const storeData = useSelector((state) => state.nidDetails);
  const storeData2 = useSelector((state) => state.uploadFilesData);
  const storeData3 = useSelector((state) => state.saveNidDetailsData);
  const storeData4 = useSelector((state) => state.deletedFilesData);
  const storeSavePan = useSelector((state) => state.savePan);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const paramData = useParams();
  const location = useLocation();
  console.log("location......", location?.state)

  const storeDataUser = useSelector((state) => state.user);
  const { userData } = storeDataUser;
  const { nidDetailsData, loading: getNIDLoading } = storeData;
  const { nidUploadFilesData, loading: uploadFileLoading } = storeData2;
  const { saveNIDDetailsData, loading: saveNIDDetailsDataLoading } = storeData3;
  const { deleteUploadedFileData, loading: deleteUploadedFileDataLoading } =
    storeData4;
  const { savePanReducerData, loading: savePanLoading } = storeSavePan;

  const [nidOptions, setnidOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [errorData, setErrorData] = useState({});
  const [addedFileName, setAddedFileName] = useState(null);
  const [deletedFileName, setDeletedFileName] = useState(null);
  const [nidFieldData, setNidFieldData] = useState("");
  const [allFields, setAllFields] = useState([]);
  const [saveData, setSaveData] = useState(false);

  const [activeTabNumber, setActiveTabNumber] = useState(1);
  const [activeCaseCheck, setActiveCaseCheck] = useState({});
  const [globalRotatedBlobObj, setGlobalRotatedBlobObj] = useState({});
  const [isDigi, setIsDigi] = useState(false);

  useEffect(() => {
    // let firstIncompleteCaseTabIndex = 0
    // if (check?.length) {
    //   firstIncompleteCaseTabIndex = check?.findIndex(caseCheck => !caseCheck?.check_status); // if it is 0 means incomplete
    //   if(activeTabNumber && selectedOption?.field_index) {
    //     //do nothing 
    //   }
    //   else if(firstIncompleteCaseTabIndex > -1) {
    //     setActiveTabNumber(firstIncompleteCaseTabIndex + 1);
    //     setActiveCaseCheck(check[firstIncompleteCaseTabIndex])
    //     // setSelectedOption({});
    //     if(location?.state){
    //       const findCompletedCheck = nid?.length && nid?.find(nidCheck => nidCheck?.case_check_id == check[0]?.case_check_id)
    //       if(findCompletedCheck?.field_index){
    //         setSelectedOption(findCompletedCheck);
    //         setIsDigi(true);
    //       }
    //     }else{
    //       setSelectedOption({});
    //     }
    //   } else {
    //     setActiveTabNumber(1);
    //     setActiveCaseCheck(check[0]);
    //     if(check[0] && check[0]?.case_check_id) {
    //       const findCompletedCheck = nid?.length && nid?.find(nidCheck => nidCheck?.case_check_id == check[0]?.case_check_id)
    //       if(findCompletedCheck?.field_index){
    //         setSelectedOption(findCompletedCheck);
    //       }
    //     }
    //   }
    // }


    if (check?.length) {
      let firstIncompleteCaseTabIndex = check.findIndex(caseCheck => !caseCheck?.check_status);
      firstIncompleteCaseTabIndex = firstIncompleteCaseTabIndex > -1 ? firstIncompleteCaseTabIndex : 0;

      if (activeTabNumber && selectedOption?.field_index) {
        // do nothing
      } else {
        handleTabChange(firstIncompleteCaseTabIndex + 1, check[firstIncompleteCaseTabIndex]);
      }
    }
  }, [check]);

  useEffect(() => {
    if (selectedOption?.field_index) {
      const field_index = selectedOption?.field_index
      const selectedFields = fields[field_index];
      let data = _.cloneDeep(selectedFields);
      if(globalRotatedBlobObj[field_index]){
        const localObj = {...globalRotatedBlobObj[field_index]}
        const fieldKeys = Object.keys(localObj || {})
        if(fieldKeys?.length) {
          fieldKeys.forEach(fieldKey => {
            const localBlob = localObj[fieldKey];
            const localURL = localBlob ? URL.createObjectURL(localBlob) : "";
            if(localURL) {
              for (var key in data) {
                if (data[key].field_name == fieldKey) {
                  data[key].value = localURL
                }
              }
            }
          })
        }
      }
      setNidFieldData(data);
    } else {
      setNidFieldData("")
    }
    localStorage.setItem('reference', paramData?.caseId)
  }, [selectedOption, fields])

  useEffect(()=>{
    if(location?.state && location?.state?.transId){
      if(digilockerCompleted == 1){
        toast.success('VERIFIED SUCCESSFULLY', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

    }
  },[digilockerCompleted])


  const getFieldName = (field, key) => {
    console.log("nid field...", field)
    if (field?.toUpperCase()?.includes("VOTER")) {
      return "Voter_Fields";
    } else if (field?.toUpperCase()?.includes("PASSPORT")) {
      return "Passport_Fields";
    } else if (field?.toUpperCase()?.includes("PAN")) {
      return "PAN_fields";
    } else if (field?.toUpperCase()?.includes("AADHAR") || field?.toUpperCase()?.includes("AADHAAR")) {
      return "Aadhaar_Fields";
    } else if (field?.toUpperCase()?.includes("DRIVING")) {
      return "Driving_Fields";
    } else return "NID-1";
  };

  const uploadFile = async (
    docCheckID,
    docSubCheckID,
    docSide,
    fieldKey,
    checkIDData,
    selectedFile,
    fieldName,
    fieldNIDIndex,
    errorField,
    activeIndex
  ) => {
    if (docSubCheckID) {
      setAddedFileName(errorField);
      //  setUnsavedNIDDetails(_.cloneDeep(nidDetails));
      // setIsLoading(true);
      await dispatch(
        uploadFileViaMultipartNID(
          docCheckID,
          docSubCheckID,
          docSide,
          fieldKey,
          activeCaseCheck?.case_check_id || checkIDData,
          selectedFile,
          fieldName,
          fieldNIDIndex,
          activeIndex,
          1,
        )
      );
      // await dispatch(getNIDDetails());
      //  await dispatch(getNIDDetailsWithOCR())

    } else {
      setAddedFileName(null);
      const msg = "Please select the document type first.";
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleFileDelete = async (recordArr, errorField, activeIndex, nidCheckid) => {
    // setIsLoading(true);
    setDeletedFileName(errorField);
    // let OCRFlag = isOCRFlag;
    await dispatch(removeUploadedFile("nid_file", recordArr, null, () => { }, activeIndex, 1, nidCheckid));
    // await dispatch(getNIDDetails());
    //  await dispatch(getNIDDetailsWithOCR())
  };

  const handleInputChange = (name, val, fieldKey, index, nidFieldIndex, inputField, ibridgeFieldId) => {
    console.log("OCR fields...", name, val) //doc_id
    // if (name && !ibridgeFieldId) {
    if (name) {
      let data = _.cloneDeep(nidFieldData);
      for (var key in data) {
        console.log(data[key]);
        if (data[key].field_name == name || data[key]?.label == name) {
          data[key].value = val
        }
      }
      setNidFieldData(data);
    }

    // else {

    //   if (ibridgeFieldId != "") {

    //     let data = _.cloneDeep(nidFieldData);
    //     for (var key in data) {
    //       console.log(data[key]);
    //       if (data[key].ibridge_field_id == ibridgeFieldId) {
    //         data[key].value = val
    //         //let name = data[key].field_name;
    //         let obj = {};
    //         obj[ibridgeFieldId] = val;
    //         setIbridgeField((prev) => ({
    //           ...prev,
    //           [ibridgeFieldId]: val
    //         }))
    //       }
    //     }
    //     setNidFieldData(data);

    //   }
    // }
  };

  const saveDateInput = (name, val, fieldKey, index, nidFieldIndex, inputField, ibridgeFieldId) => {
    if (name) {
      let data = _.cloneDeep(nidFieldData);
      for (var key in data) {
        console.log(data[key]);
        if (data[key].field_name == name) {
          data[key].value = val
        }
      }
      setNidFieldData(data);
    }
    // else{
    //   if(ibridgeFieldId != ""){

    //     let data = _.cloneDeep(nidFieldData);
    //     for(var key in data){
    //       console.log(data[key]);
    //       if(data[key].ibridge_field_id == ibridgeFieldId){
    //         data[key].value = val
    //         //let name = data[key].field_name;
    //         let obj={};
    //         obj[ibridgeFieldId]=val;
    //         setIbridgeField((prev) => ({
    //           ...prev,
    //         [ibridgeFieldId]: val
    //         }))
    //       }
    //     }
    //       setNidFieldData(data);

    //   }
    // }
  }

  // const handleContinueRedirection = (data) => {
  //   // let allFields = Object.keys(tabs);
  //   let field = "";
  //   let key;

  //     const isNidPending=data?.group?.is_nid_pending;
  //     // if(isNidPending){
  //     //   let name = getNextTabName();
  //     //   if(name){
  //     //   localStorage.setItem('NIDSaved', false);
  //     //       field = name;
  //     //   }

  //     // }else{
  //       handleRedirectContinue(data);
  //     // }

  //   // }
  //     setSelectedField(field);
  //     // setAllFields(allFields);

  //     setNidFieldData(nidDetailsNew?.fields[field]);
  //     // getFieldName(field);
  //     if (nidDetails?.["check_status"]?.[field]) setSaveData(true);

  // }

  const handleRedirectContinue = (data) => {
    const referenceNumber = paramData?.caseId;
    if (referenceNumber) {
      const groupID = data?.group?.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
      dispatch(deleteSaveNIDDetails());
      localStorage.removeItem('activeNIDTab');
      localStorage.removeItem('NIDSaved');
    }
  }

  const handleTabChange = (tabNumber, checkData) => {
    setActiveTabNumber(tabNumber);
    setActiveCaseCheck(checkData);

    const associatedCheck =  nid?.find(nidOption => nidOption.case_check_id === checkData?.case_check_id);
    if(associatedCheck) {
      setSelectedOption(associatedCheck);
      if(digilockerCompleted == 1){
        setIsDigi(true);
      }else if(digilockerCompleted == 0){
        setIsDigi(false);
      }
    } else {
      const findIncompleteOption = nid?.filter(nidOption => !nidOption.case_check_id);
      if (findIncompleteOption?.length === 1) {
        setSelectedOption(findIncompleteOption[0] || {});
        if(location?.state){
          setIsDigi(true);
        }
      } else {
        if(location?.state){
          const findCompletedCheck = nid?.length && nid?.find(nidCheck => nidCheck?.case_check_id == check[0]?.case_check_id)
          if(findCompletedCheck?.field_index){
            setSelectedOption(findCompletedCheck);
            setIsDigi(true);
          }
        }else{
          setSelectedOption({});
        }
      }
    }

  }


  return (
    <div
      className=""
      style={{
        maxWidth: "100%",
        overflowX: "hidden",
        background: "#F9FAFB",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="col-sm-12 col-md-12 col-xl-4">
          <div className="header py-2">
            <div
              className="btn-group p-0 mb-2 d-block pb-2"
              style={{
                borderRadius: "18px !important",
                whiteSpace: "nowrap",
                overflowX: "auto", // Enable horizontal scrolling
                WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS devices
                scrollSnapType: "x proximity", // Snap to nearest button
              }}
              role="group"
              aria-label="Basic example"
            >
              {check.map((checkData, index) => {
                const tabNumber = index + 1;
                return (
                  <button
                    type="button"
                    style={{
                      backgroundColor: `${tabNumber === activeTabNumber ? "#edf8ff" : "transparent"
                        }`,
                    }}
                    className={`btn  text-dark px-3 py-2 ${false
                      ? "completed"
                      : ""
                      }  ${tabNumber === activeTabNumber ? "active" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTabChange(tabNumber, checkData);
                    }}
                  >
                    {`NID-${tabNumber}`}<sup className="text-danger">*</sup>
                    {checkData?.check_status ? (
                      <span>
                        <img className="pb-1 ml-1" src={tick} alt="tick" />
                      </span>
                    ) : (
                      ""
                    )}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="row">
            <InstantNIDDropDown
              name={`instant_nid_dropdown`}
              id={`instant_nid_dropdown`}
              label={'NID'}
              autoComplete="off"
              options={nid || []}
              isRequired={1}
              handleSelectChange={(option) => { setSelectedOption(option) }}
              checkDetailsIndex={0}
              fieldName={"instant_nid_dropdown"}
              fieldValue={selectedOption?.label}
              hasError={false}
              isDisabled={!!(selectedOption?.field_index && (check_status[selectedOption?.field_index] || selectedOption?.case_check_id ))}
              activeCaseCheck={activeCaseCheck}
            />
          </div>
        </div>
        {
          !!(selfie[0] && selfie[0].preview_key) &&
          <div className='only-desktop-viewer'>
            <div className="d-flex flex-column align-items-center" style={{ gap: 2 }}>
              <span>Selfie</span>
              <img
                src={selfie[0].preview_key}
                className="img-fluid"
                style={{ height: "160px", boxShadow: "0px 0px 6px 0px #666", borderRadius: 8 }}
              />
            </div>
          </div>
        }

      </div>

      <>
        {
          !!(nidFieldData && fields[selectedOption?.field_index]) &&
          <InstantNIDForm
            field={nidFieldData}
            nidAllDetails={nidDetails}
            nidOptions={nidDetails.Default_Nid_Dropdown}
            fieldKey={selectedOption?.field_index}
            errorData={errorData}
            key={selectedOption?.field_index}
            handleInputChange={handleInputChange}
            uploadFile={uploadFile}
            handleFileDelete={handleFileDelete}
            selectedFieldName={selectedOption?.label}
            ibridgeField={{}}
            saveDateInput={saveDateInput}
            activeCaseCheck={activeCaseCheck}
            isDigi={isDigi}
            handleContinueRedirection={(data) => {
              if (data?.group?.is_nid_pending) {
                if (check[activeTabNumber]) {
                  handleTabChange(activeTabNumber + 1, check[activeTabNumber]);
                } else {
                  setSelectedOption({});
                }
              } else {
                handleRedirectContinue(data);
              }
            }}
            getIsMandatoryFlag={() => { return false }}
            globalRotatedBlobObj={globalRotatedBlobObj}
            setGlobalRotatedBlobObj={setGlobalRotatedBlobObj}
          />
        }
      </>
    </div>
  )
}

export default IntantNIDContainer;
